(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function setupArticleSharing(root=document){
    root.querySelectorAll('[data-article-share]').forEach(box=>{
      if(box.dataset.ready)return;
      box.dataset.ready='true';
      const status=box.querySelector('[data-share-status]');
      const fallback=box.querySelector('[data-share-fallback]');
      const copy=async()=>{
        try{
          await navigator.clipboard.writeText(box.dataset.url);
          fallback.hidden=true;
          status.textContent=box.dataset.copied;
        }catch(error){
          fallback.hidden=false;
          fallback.focus();
          fallback.select();
          status.textContent=box.dataset.fallback;
        }
      };
      box.querySelector('[data-copy-link]').addEventListener('click',copy);
      const native=box.querySelector('[data-native-share]');
      if(typeof navigator.share==='function'){
        native.hidden=false;
        native.addEventListener('click',async()=>{
          try{await navigator.share({title:box.dataset.title,url:box.dataset.url});}
          catch(error){if(error.name!=='AbortError')await copy();}
        });
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setupArticleSharing(),{once:true});
  else setupArticleSharing();
  document.addEventListener('shopify:section:load',event=>setupArticleSharing(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-recommendations][aria-busy="true"]');

    sections.forEach((recommendationSection) => {
      const loadRecommendations = () => {
        fetch(recommendationSection.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const refreshed = parsed.querySelector('[data-product-recommendations]');

            if (refreshed && refreshed.innerHTML.trim()) {
              recommendationSection.innerHTML = refreshed.innerHTML;
              recommendationSection.setAttribute('aria-busy', 'false');
            } else {
              recommendationSection.remove();
            }
          })
          .catch(() => recommendationSection.remove());
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, { rootMargin: '0px 0px 320px 0px' });
        observer.observe(recommendationSection);
      } else {
        loadRecommendations();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
